import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { ChooseLogo } from '@/components/ui/choose-logo';
import { trackEvent } from '@/lib/mixpanel';

export default function NotFoundPage() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    trackEvent('NOT_FOUND_VIEWED', { path: location.pathname });
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4">
      <ChooseLogo width={90} height={90} />
      <h1 className="text-4xl font-bold">{t('page.not_found.title')}</h1>
      <p className="text-muted-foreground">{t('page.not_found.message')}</p>
    </div>
  );
}
